import { mtrStatusField } from '@/const/underwriting/motor'
import store from '@/store'

export const noClmStatus = (value) => {
  let result = 'A'
  if (value !== null) {
    const noClmList = store.state.agency.quotation.motorParam.permStatuses.filter(status => status.statusField === mtrStatusField.NOCLM)
    result = checkStatuses(noClmList, value, 'int')
  }
  return result
}

export const clmAmtStatus = (value) => {
  let result = 'A'
  if (value !== null) {
    const clmAmtList = store.state.agency.quotation.motorParam.permStatuses.filter(status => status.statusField === mtrStatusField.CLMAMT)
    result = checkStatuses(clmAmtList, value, 'number')
  }
  return result
}

export const isDrvStatus = (value) => {
  let result = 'A'
  if (value !== null) {
    const isDrvList = store.state.agency.quotation.motorParam.permStatuses.filter(status => status.statusField === mtrStatusField.ISDRV)
    result = checkStatuses(isDrvList, value, 'bool')
  }
  return result
}

export const drvExpStatus = (value) => {
  let result = 'A'
  if (value !== null) {
    const drvExpList = store.state.agency.quotation.motorParam.permStatuses.filter(status => status.statusField === mtrStatusField.DRVEXP)
    result = checkStatuses(drvExpList, value, 'int')
  }
  return result
}

export const drvAgeStatus = (value) => {
  let result = 'A'
  if (value !== null) {
    const drvAgeList = store.state.agency.quotation.motorParam.permStatuses.filter(status => status.statusField === mtrStatusField.DRVAGE)
    result = checkStatuses(drvAgeList, value, 'int')
  }
  return result
}

export const vehRegYrStatus = (value) => {
  let result = 'A'
  if (value !== null) {
    const vehRegList = store.state.agency.quotation.motorParam.permStatuses.filter(status => status.statusField === mtrStatusField.VEHREGYR)
    result = checkStatuses(vehRegList, value, 'int')
  }
  return result
}

/**
 * Private functions to check permit statuses from the list
 */
function checkStatuses(list, value, type) {
  try {
    let result = 'A'
    if (list && list.length > 0) {
      list.map(status => {
        const tempResult = checkStatus(status, value, type)
        if (tempResult === 'R') {
          if (result !== 'D') {
            result = tempResult
          }
        } else if (tempResult === 'D') {
          result = tempResult
        }
      })
    }
    return result
  } catch (err) {
    console.log(err)
    return 'D'
  }
}
function checkStatus(status, value, type = 'str') {
  try {
    let result = 'A'
    if (status !== null && value !== null) {
      let statusVal = status.value
      if (type === 'int') {
        statusVal = parseInt(status.value)
      } else if (type === 'number') {
        statusVal = Number(status.value)
      } else if (type === 'bool') {
        if (status.value === '1' || status.value === 'true') {
          statusVal = true
        } else {
          statusVal = false
        }
      }

      if (checkOperator(value, status.operator, statusVal)) {
        result = status.permitStatus
      }
    }
    return result
  } catch (err) {
    throw err
  }
}

function checkOperator(value, operator, statusVal) {
  if (operator === '==') {
    return value === statusVal
  } else if (operator === '>') {
    return value > statusVal
  } else if (operator === '>=') {
    return value >= statusVal
  } else if (operator === '<') {
    return value < statusVal
  } else if (operator === '<=') {
    return value <= statusVal
  } else if (operator === '!=') {
    return value !== statusVal
  } else {
    return false
  }
}
